// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel';

export type OperatorTypeEnum = 'MIX' | 'MAX' | 'SUM';

export type UniqueTypeEnum =
    | 'ADDRESS_STATE'
    | 'CITY'
    | 'LOCALITY'
    | 'LAT_LONG'
    | 'LOCATION_ID';
export type FilterOnTypeEnum = 'START_ONLY' | 'EXCLUDING_START' | 'NONE';

export type CostParameterModelType = {
    parameterType: ?string,
    uniqueType: ?UniqueTypeEnum,
    filterOn: ?FilterOnTypeEnum,
    operator: ?OperatorTypeEnum
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class CostParameter extends ImmutableModel {
    static fromJS(json: CostParameterModelType): CostParameter {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): CostParameterModelType {
        return {
            parameterType: this.parameterType,
            uniqueType: this.uniqueType,
            filterOn: this.filterOn,
            operator: this.operator
        };
    }

    get parameterType(): ?string {
        return this._state.get('parameterType');
    }

    setParameterType(parameterType: ?string): this {
        return this.clone(this._state.set('parameterType', parameterType));
    }

    get uniqueType(): ?UniqueTypeEnum {
        return this._state.get('uniqueType');
    }

    setUniqueType(uniqueType: ?UniqueTypeEnum): this {
        return this.clone(this._state.set('uniqueType', uniqueType));
    }

    get filterOn(): ?FilterOnTypeEnum {
        return this._state.get('filterOn');
    }

    setFilterOn(filterOn: ?FilterOnTypeEnum): this {
        return this.clone(this._state.set('filterOn', filterOn));
    }

    get operator(): ?OperatorTypeEnum {
        return this._state.get('operator');
    }

    setOperator(operator: ?OperatorTypeEnum): this {
        return this.clone(this._state.set('operator', operator));
    }
}
